// extracted by mini-css-extract-plugin
export var content = "_oe-1";
export var fullScreen = "_oe-0";